import { useState } from "react";
import { navItems } from "../data/navigation.js";
import { isActivePath } from "../utils/path.js";
import { withBase } from "../utils/sitePaths.js";

export default function Header({ currentPath }) {
  const [menuOpen, setMenuOpen] = useState(false);

  function handleNavigate() {
    setMenuOpen(false);
  }

  return (
    <header className="site-header">
      <a className="brand" href={withBase("/")} onClick={handleNavigate}>
        <span className="brand-mark">CG</span>
        <span>
          <strong>ContiGO</strong>
          <small>Freeze Foods</small>
        </span>
      </a>

      <button
        className="menu-toggle"
        type="button"
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((value) => !value)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={menuOpen ? "nav nav-open" : "nav"} aria-label="Primary navigation">
        {navItems.map((item) => (
          <a
            key={item.path}
            href={withBase(item.path)}
            className={isActivePath(currentPath, item.path) ? "active" : ""}
            onClick={handleNavigate}
          >
            {item.label}
          </a>
        ))}
        <a className="nav-cta" href={withBase("/contact")} onClick={handleNavigate}>
          Request Catalog
        </a>
      </nav>
    </header>
  );
}
